import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import { MaterialIcons } from '../PlatformSpecificIcons';
import Card from './Card';
import colors from '../../config/colors';

/**
 * StatusCard - Shows online/offline status and device name with rename button
 */
function StatusCard({
    isConnected,
    deviceName,
    onRenamePress,
    style
}) {
    return (
        <Card style={[styles.container, style]}>
            {/* Status Badge */}
            <View style={styles.statusRow}>
                <View style={[
                    styles.statusBadge,
                    isConnected ? styles.statusOnline : styles.statusOffline
                ]}>
                    <Text style={styles.statusText}>
                        {isConnected ? 'Online and Connected' : 'Offline'}
                    </Text>
                </View>
            </View>

            {/* Device Name */}
            <View style={styles.nameRow}>
                <Text style={styles.deviceName}>{deviceName}</Text>
                {onRenamePress && (
                    <TouchableOpacity onPress={onRenamePress} style={styles.renameButton}>
                        <MaterialIcons name="drive-file-rename-outline" size={22} color={colors.primary} />
                    </TouchableOpacity>
                )}
            </View>
        </Card>
    );
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
    },
    statusRow: {
        marginBottom: 12,
    },
    statusBadge: {
        paddingHorizontal: 20,
        paddingVertical: 8,
        borderRadius: 20,
    },
    statusOnline: {
        backgroundColor: '#33cc33',
    },
    statusOffline: {
        backgroundColor: 'red',
    },
    statusText: {
        color: colors.white,
        fontWeight: 'bold',
        fontSize: 14,
    },
    nameRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    deviceName: {
        fontSize: 18,
        fontWeight: 'bold',
        color: colors.dark,
    },
    renameButton: {
        marginLeft: 8,
        padding: 4,
    },
});

export default StatusCard;
